import { useAcknowledgeAlert, useAlerts } from '../lib/api/alerts'

export function CashgapBanner() {
  const { data } = useAlerts({ status: 'open' })
  const ack = useAcknowledgeAlert()
  const items = data?.items ?? []

  if (items.length === 0) return null

  // Show the worst (critical takes priority, then most recent)
  const worst = items.reduce((acc, x) => (x.severity === 'critical' ? x : acc), items[0])
  const p = worst.payload

  return (
    <div
      style={{
        background: 'var(--danger-bg, rgba(248,113,113,0.08))',
        borderBottom: '1px solid rgba(248,113,113,0.3)',
        color: 'var(--danger-fg, #b91c1c)',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
      }}
    >
      <span role="img" aria-label="Попередження">🚨</span>
      <div style={{ flex: 1 }}>
        Прогноз касового розриву на тиждень з {p.weekStart}: проєкційний баланс{' '}
        <strong>
          {new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(p.projectedClose)} UAH
        </strong>{' '}
        (поріг {new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(p.threshold)} UAH).
        <a
          href="/forecast"
          style={{ marginLeft: 8, color: 'inherit', textDecoration: 'underline', fontWeight: 600 }}
        >
          Переглянути прогноз
        </a>
      </div>
      <button
        type="button"
        onClick={() => ack.mutate(worst.id)}
        aria-label="Закрити"
        disabled={ack.isPending}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'inherit',
          fontSize: 16,
          lineHeight: 1,
          opacity: ack.isPending ? 0.5 : 1,
          padding: '2px 4px',
        }}
      >
        ✕
      </button>
    </div>
  )
}
